import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { connect, useSelector } from "react-redux"
import { Link, useLocation, useParams } from "react-router-dom"
// Redux Store
import { showRightSidebarAction, toggleLeftmenu } from "../../store/actions"
// reactstrap
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import zithasLogo from "../../assets/images/zithas-logo.png"
// import Css
import "../../assets/css/Layout/Header.css"
//i18n
import { withTranslation } from "react-i18next"
import configure from "configure"
import secureLocalStorage from "react-secure-storage"
import { parsePermissionList } from "utils/common-helpers"

const Header = props => {
  const [roles, setRoles] = useState([])

  // Get roles: 
  const allRoles = useSelector((state) => state?.Roles?.apiData)
  // const auth = useSelector((state) => state)

  const calenderUrl = useLocation()
  const calender3 = calenderUrl.pathname
  const usepara = useParams()

  useEffect(() => {
    setRoles(
      (Array.isArray(allRoles) ? allRoles : []).map(item =>
        parsePermissionList(item?.permission)
      )
    )
    const authRole = secureLocalStorage.getItem('auth_role')
    if (authRole == null) {
      secureLocalStorage.setItem('auth_role', allRoles[0]?.roleid)
    }
  }, [])

  function filterInnerArraysById(id) {
    return roles.map(innerArray => {
      return innerArray.filter(element => {
        const parts = element.split(",")
        const elementId = parseInt(parts[0])
        return elementId === id
      })
    })
  }

  return (
    <React.Fragment>
      <header id="page-topbar" className="Header">
        <div
          className={`navbar-header px-0 ${calender3 === `${configure.appUrl}calendar` ||
            calender3 === `${configure.appUrl}calender/${usepara.id}`
            ? "height-50"
            : ""
            }`}
        >
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to={`${configure.appUrl}`} className="logo logo-light">
                <span>
                  <img
                    src={zithasLogo}
                    alt="zithas logo"
                    className="zithas-logo"
                    height="48"
                  />
                </span>
              </Link>
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 d-lg-none header-item"
              data-toggle="collapse"
              onClick={() => {
                props.toggleLeftmenu(!props.leftMenu)
              }}
              data-target="#topnav-menu-content"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
          </div>
          {/* <TimerProvider>
            <TimerChange />
          </TimerProvider> */}

          {/* Knowledge Base */}

          <div className="d-flex">
            <div className="d-flex align-items-center me-3">
              {filterInnerArraysById(95)
                .map(item => item[0]?.split(",").map(Number)[2])
                .includes(1) == true ? (
                <Link
                  className="nav-link dropdown-toggle arrow-none"
                  to={`${configure.appUrl}knowledgebase`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="bi bi-book-fill text-white"></i>
                  <span className="text-white">&nbsp; Knowledge Base</span>
                </Link>
              ) : null}
            </div>
            <div className="d-flex align-items-center">
              {filterInnerArraysById(85)
                .map(item => item[0]?.split(",").map(Number)[2])
                .includes(1) == true ? (
                <Link
                  className="nav-link dropdown-toggle arrow-none"
                  to={`${configure.appUrl}calendar`}
                  target="_blank"
                  rel="noreferrer"
                // onClick={() => setCalenderPopup(true)}
                >
                  <i className="fa fa-calendar text-white"></i>
                  <span className="text-white">&nbsp; Calendar</span>
                </Link>
              ) : null}
            </div>

            <div className="d-flex align-items-center ms-3">
              <Link
                className="nav-link dropdown-toggle arrow-none"
                to={`${configure.appUrl}guidelines-policy`}
                target="_blank"
                rel="noreferrer"
                title="General Guidelines & Policy"
              >
                <i className="bi bi-file-earmark-text-fill text-white"></i>
                <span className="text-white">&nbsp; Policy</span>
              </Link>
            </div>

            <ProfileMenu />

            <NotificationDropdown />

          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu } = state.Layout
  return { layoutType, showRightSidebar, leftMenu }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
})(withTranslation()(Header))
